import { render, staticRenderFns } from "./pwa_generate.vue?vue&type=template&id=07aef5e2&scoped=true&"
import script from "./pwa_generate.vue?vue&type=script&lang=js&"
export * from "./pwa_generate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aef5e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07aef5e2')) {
      api.createRecord('07aef5e2', component.options)
    } else {
      api.reload('07aef5e2', component.options)
    }
    module.hot.accept("./pwa_generate.vue?vue&type=template&id=07aef5e2&scoped=true&", function () {
      api.rerender('07aef5e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pwa_generate/pwa_generate.vue"
export default component.exports